export default "slx"